!(function () {
  "use strict";
  var e = {
      208: function () {
        window.addEventListener("DOMContentLoaded", () => {
          xoGroup.on("change", ({ element: e, index: t }) => {
            const s = document.querySelectorAll(".filters-content__grid"),
              n = document.querySelector("xo-filters-content");
            let i = Number(e.innerHTML);
            (s?.forEach((e) =>
              e.setAttribute(
                "style",
                `--xs: {{ columns_mobile }}; --sm: {{ columns_mobile }}; --md: {{ columns_desktop | minus: 1 }};--lg:${i}`,
              ),
            ),
              n &&
                n.handleContent((e) => {
                  const t = new DOMParser().parseFromString(e, "text/html"),
                    s = t.querySelectorAll(".filters-content__grid");
                  return (
                    s?.forEach((e) =>
                      e.setAttribute(
                        "style",
                        `--xs: {{ columns_mobile }}; --sm: {{ columns_mobile }}; --md: {{ columns_desktop | minus: 1 }};--lg:${i}`,
                      ),
                    ),
                    t.body.innerHTML
                  );
                }));
          });
        });
      },
      439: function () {
        let e = null;
        cartSubscribe((t) => {
          const s = document.querySelector("#xo-notify");
          if (null !== e && t.size > e && s) {
            s.classList.add("cart-drawer-hidden");
            const e = setTimeout(() => {
              (s.classList.remove("cart-drawer-hidden"), clearTimeout(e));
            }, 3e3);
          }
          e = t.size;
        });
      },
      505: function () {
        window.addEventListener("DOMContentLoaded", () => {
          const e = document.querySelectorAll(
              "#menu-hamburger-drawer-content xo-mega-menu",
            ),
            t = document.querySelectorAll(
              "#menu-hamburger-drawer-trigger #xo-menu-hamburger__arrow",
            );
          e.forEach((e, s) => {
            0 === e.children.length && (t[s].style.display = "none");
          });
        });
      },
      975: function () {
        const e = document.querySelector("#xo-scroll-top");
        window.addEventListener("scroll", () => {
          window.scrollY >= 700
            ? e?.classList.add("xo-active")
            : e?.classList.remove("xo-active");
        });
      },
    },
    t = {};
  function s(n) {
    var i = t[n];
    if (void 0 !== i) return i.exports;
    var o = (t[n] = { exports: {} });
    return (e[n](o, o.exports, s), o.exports);
  }
  const n = (e, t, s) => {
    s ? e.setAttribute(t, "") : e.removeAttribute(t);
  };
  function i(e, t) {
    for (let s = 0; s < e.length; s++) t(e[s], s, e);
  }
  const o = (e) => Object.keys(e);
  function r(e, t) {
    i(o(e), (s) => {
      customElements.get(s) || customElements.define(s, e[s], t);
    });
  }
  function a(e, t) {
    const s = [];
    for (let n = 0; n < e.length; n++) t(e[n], n, e) && s.push(e[n]);
    return s;
  }
  class l {
    id;
    events;
    constructor() {
      ((this.id = 0), (this.events = {}));
    }
    on(e, t) {
      return (
        this.id++,
        (this.events = {
          ...this.events,
          [e]: [...(this.events[e] || []), { listener: t, id: this.id }],
        }),
        this.id
      );
    }
    off(e) {
      for (const t in this.events)
        this.events = {
          ...this.events,
          [t]: a(this.events[t], (t) => t.id !== e),
        };
    }
    emit(e, t) {
      this.events[e] &&
        i(this.events[e], ({ listener: e }) => {
          e(t);
        });
    }
  }
  function c(e = 0) {
    return new Promise((t) => {
      const s = window.setTimeout(() => {
        (t(() => window.clearTimeout(s)), clearTimeout(s));
      }, e);
    });
  }
  function u(e) {
    /comp|inter/.test(document.readyState)
      ? e()
      : "addEventListener" in document
        ? document.addEventListener("DOMContentLoaded", e)
        : document.attachEvent("onreadystatechange", () => {
            "complete" === document.readyState && e();
          });
  }
  const h = {
    linear: (e) => e,
    ease: (e) => 0.5 * (1 - Math.cos(Math.PI * e)),
    easeInQuad: (e) => e * e,
    easeOutQuad: (e) => e * (2 - e),
    easeInOutQuad: (e) => (e < 0.5 ? 2 * e * e : (4 - 2 * e) * e - 1),
    easeInCubic: (e) => e * e * e,
    easeOutCubic: (e) => --e * e * e + 1,
    easeInOutCubic: (e) =>
      e < 0.5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1,
    easeInQuart: (e) => e * e * e * e,
    easeOutQuart: (e) => 1 - --e * e * e * e,
    easeInOutQuart: (e) =>
      e < 0.5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e,
    easeInQuint: (e) => e * e * e * e * e,
    easeOutQuint: (e) => 1 + --e * e * e * e * e,
    easeInOutQuint: (e) =>
      e < 0.5 ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e,
    easeOutBounce: (e) => {
      const t = 7.5625,
        s = 2.75;
      return e < 1 / s
        ? t * e * e
        : e < 2 / s
          ? t * (e -= 1.5 / s) * e + 0.75
          : e < 2.5 / s
            ? t * (e -= 2.25 / s) * e + 0.9375
            : t * (e -= 2.625 / s) * e + 0.984375;
    },
    easeInBounce: (e) => 1 - h.easeOutBounce(1 - e),
    easeOutBack: (e) => 1 + 2.70158 * (e - 1) ** 3 + 1.70158 * (e - 1) ** 2,
    easeInBack: (e) => 2.70158 * e * e * e - 1.70158 * e * e,
    easeInOut: (e) =>
      e < 0.5 ? h.easeInBack(2 * e) / 2 : h.easeOutBack(2 * e - 1) / 2 + 0.5,
    easeInElastic: (e) => {
      const t = (2 * Math.PI) / 3;
      return 0 === e
        ? 0
        : 1 === e
          ? 1
          : -(2 ** (10 * e - 10)) * Math.sin((10 * e - 10.75) * t);
    },
    easeOutElastic: (e) => {
      const t = (2 * Math.PI) / 3;
      return 0 === e
        ? 0
        : 1 === e
          ? 1
          : 2 ** (-10 * e) * Math.sin((10 * e - 0.75) * t) + 1;
    },
    easeInExpo: (e) => (0 === e ? 0 : 2 ** (10 * e - 10)),
    easeOutExpo: (e) => (1 === e ? 1 : 1 - 2 ** (-10 * e)),
    spring: (e) => 1 - Math.cos(4.5 * e * Math.PI) * Math.exp(6 * -e),
    decay: (e) => 1 - Math.exp(6 * -e),
  };
  function d(e, t) {
    const s = [];
    for (let n = 0; n < e.length; n++) s.push(t(e[n], n, e));
    return s;
  }
  function p(e) {
    return e.replace(/[A-Z]/g, (e) => `_${e.toLowerCase()}`);
  }
  function m(e) {
    return e.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
  }
  new (class {
    frameId;
    keepAliveFrameId;
    lastTimestamp;
    frames;
    keepAliveFrames;
    defaultTimestep;
    constructor() {
      ((this.frameId = null),
        (this.keepAliveFrameId = null),
        (this.lastTimestamp = null),
        (this.frames = []),
        (this.keepAliveFrames = []),
        (this.defaultTimestep = (1 / 60) * 1e3));
    }
    handleFrameLoop = (e) => {
      if (this.lastTimestamp) {
        const t = e - this.lastTimestamp;
        i(this.keepAliveFrames, (s) =>
          s.call(this, { delta: t, timestamp: e }),
        );
      }
      ((this.lastTimestamp = e),
        this.keepAliveFrameId && cancelAnimationFrame(this.keepAliveFrameId),
        (this.keepAliveFrameId = requestAnimationFrame(this.handleFrameLoop)));
    };
    handleFrame = (e) => {
      i(this.frames, (t) =>
        t.call(this, { delta: this.defaultTimestep, timestamp: e }),
      );
    };
    getFrames = () => this.frames;
    add = (e, t = !1) => (
      this.cancelFrame(),
      this.frames.includes(e) || this.frames.push(e),
      t && !this.keepAliveFrames.includes(e) && this.keepAliveFrames.push(e),
      this.start(),
      this
    );
    start = () => {
      ((this.frameId = requestAnimationFrame(this.handleFrame)),
        (this.keepAliveFrameId = requestAnimationFrame(this.handleFrameLoop)));
    };
    cancelFrame = () => {
      (null != this.frameId &&
        (cancelAnimationFrame(this.frameId), (this.frameId = null)),
        null != this.keepAliveFrameId &&
          (cancelAnimationFrame(this.keepAliveFrameId),
          (this.keepAliveFrameId = null)));
    };
    stopFrame = (e, t) => {
      const s = e.indexOf(t);
      (-1 !== s && e.splice(s, 1),
        0 === e.length && (this.cancelFrame(), (this.lastTimestamp = null)));
    };
    remove = (e) => (
      this.stopFrame(this.frames, e),
      this.stopFrame(this.keepAliveFrames, e),
      this
    );
    clear = () => (
      (this.frames = []),
      (this.keepAliveFrames = []),
      this.cancelFrame(),
      (this.lastTimestamp = null),
      this
    );
  })();
  const f = {
    snakeToCamel: function (e) {
      return e.replace(/([_]\w)/g, (e) => e[1].toUpperCase());
    },
    snakeToPascal: function (e) {
      return e
        .replace(/(\-\w|\_\w)/g, (e) => e[1].toUpperCase())
        .replace(/^(\w)/, (e) => e[0].toUpperCase());
    },
    camelToSnake: p,
    camelToPascal: function (e) {
      return e.replace(/^(\w)/, (e) => e[0].toUpperCase());
    },
    pascalToSnake: function (e) {
      return p(e).replace(/^_/g, "");
    },
    pascalToCamel: function (e) {
      return e.replace(/^(\w)/, (e) => e[0].toLowerCase());
    },
    kebabToCamel: function (e) {
      return e.replace(/([-]\w)/g, (e) => e[1].toUpperCase());
    },
    kebabToPascal: function (e) {
      return e
        .replace(/([-]\w)/g, (e) => e[1].toUpperCase())
        .replace(/^(\w)/, (e) => e[0].toUpperCase());
    },
    camelToKebab: m,
    pascalToKebab: function (e) {
      return m(e).replace(/^-/g, "");
    },
  };
  function v(e) {
    const t = e.trim();
    if (!/^{|\[/g.test(t)) return {};
    try {
      const e = new Function(`return ${t}`)();
      return JSON.parse(JSON.stringify(e));
    } catch {
      return /^\[/g.test(t) ? [] : {};
    }
  }
  function y(e, t) {
    switch (t) {
      case "string":
      default:
        return e;
      case "number":
        return Number(e);
      case "string | number": {
        const t = Number(e);
        return isNaN(t) ? e : t;
      }
      case "boolean":
        return "true" === e || "" === e;
      case "object":
      case "array":
        return v(e);
    }
  }
  function g(
    e,
    { pick: t, types: s, camelCase: n = !0, propTransformer: i } = {},
  ) {
    let o = {};
    if (null == e) return o;
    const r = Array.from(e.attributes);
    null == t && (t = d(r, (e) => e.name));
    for (const e of r) {
      let r = n ? f.kebabToCamel(e.name) : e.name;
      const a = s?.[r];
      null != e.value &&
        t?.includes(r) &&
        ("function" == typeof i && (r = i(r)),
        (o =
          s && null != a
            ? { ...o, [r]: y(e.value, a) }
            : { ...o, [r]: e.value }));
    }
    return o;
  }
  (navigator.userAgent.match(/Android/i),
    navigator.userAgent.match(/BlackBerry/i),
    navigator.userAgent.match(/iPad/i),
    navigator.userAgent.match(/iPhone|iPad|iPod/i),
    navigator.userAgent.match(/Opera Mini/i),
    navigator.userAgent.match(/Windows Phone/i),
    navigator.userAgent.match(/(?:SD4930UR|\\bSilk(?:.+)Mobile\\b)/i),
    navigator.userAgent.match(/Silk/i));
  const b = !!navigator.userAgent.match(
    /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|Windows Phone|(?:SD4930UR|\bSilk(?:.+)Mobile\b)|Silk/i,
  );
  u(() => {
    const e = document.documentElement;
    b ? e.classList.add("is-mobile") : e.classList.add("is-desktop");
  });
  const w = (e) => Object.values(e);
  function x(e) {
    const t = e?.ownerDocument,
      s = t.documentElement,
      n = (function (e) {
        return 9 === e.nodeType && e.defaultView;
      })(t);
    let i = { top: 0, left: 0 };
    return t
      ? (void 0 !== e.getBoundingClientRect && (i = e.getBoundingClientRect()),
        {
          top: i.top + n.scrollY - s.clientTop,
          left: i.left + n.scrollX - s.clientLeft,
        })
      : { top: 0, left: 0 };
  }
  class _ {
    dx;
    dy;
    vx = 0;
    vy = 0;
    isStart = !1;
    startX = 0;
    startX2 = 0;
    startY = 0;
    startY2 = 0;
    options;
    constructor(e) {
      ((this.options = e),
        (this.dx = e.dx || 0),
        (this.dy = e.dy || 0),
        e.element.addEventListener("mousedown", this.handleMouseDown),
        b && e.element.addEventListener("touchstart", this.handleMouseDown));
    }
    handleMouseDown = (e) => {
      const { onStart: t } = this.options;
      if ("touchstart" === e.type && e.touches.length > 1) return;
      if ("mousedown" === e.type && 0 !== e.button) return;
      const s = e.target;
      (b || (!s.closest("a") && !s.closest("img")) || e.preventDefault(),
        (this.isStart = !0),
        "touchstart" === e.type
          ? ((this.startX = e.touches[0].clientX),
            (this.startY = e.touches[0].clientY),
            (this.startX2 = e.touches[0].clientX),
            (this.startY2 = e.touches[0].clientY))
          : ((this.startX = e.clientX),
            (this.startY = e.clientY),
            (this.startX2 = e.clientX),
            (this.startY2 = e.clientY)),
        t?.(e),
        document.addEventListener("mousemove", this.handleMouseMove),
        document.addEventListener("touchmove", this.handleMouseMove, {
          passive: !1,
        }),
        document.addEventListener("mouseup", this.handleMouseUp),
        document.addEventListener("touchend", this.handleMouseUp));
    };
    handleMouseMove = (e) => {
      const { onMove: t } = this.options;
      if ("touchmove" === e.type && e.touches.length > 1) return;
      if ("mousemove" === e.type && 0 !== e.button) return;
      if ((b || e.preventDefault(), !this.isStart)) return;
      let s, n;
      "touchmove" === e.type
        ? ((s = e.touches[0].clientX), (n = e.touches[0].clientY))
        : ((s = e.clientX), (n = e.clientY));
      const i = s - this.startX,
        o = n - this.startY;
      ((this.startX = s),
        (this.startY = n),
        (this.dx += i),
        (this.dy += o),
        (this.vx = i),
        (this.vy = o),
        t?.(
          {
            dx: this.dx,
            dy: this.dy,
            vx: this.vx,
            vy: this.vy,
            isHorizontalSwipe:
              Math.abs(s - this.startX2) > Math.abs(n - this.startY2),
          },
          e,
        ));
    };
    handleEnd = (e, t) => {
      const { onEnd: s } = this.options;
      this.isStart &&
        ((this.isStart = !1),
        t &&
          ((this.dx = t.dx),
          (this.dy = t.dy),
          (this.vx = t.vx),
          (this.vy = t.vy)),
        s?.({ dx: this.dx, dy: this.dy, vx: this.vx, vy: this.vy }, e),
        document.removeEventListener("mousemove", this.handleMouseMove),
        document.removeEventListener("touchmove", this.handleMouseMove),
        document.removeEventListener("mouseup", this.handleMouseUp),
        document.removeEventListener("touchend", this.handleMouseUp));
    };
    handleMouseUp = (e) => {
      (b || e.preventDefault(), this.handleEnd(e));
    };
    setValue = ({ dx: e, dy: t }) => {
      (null != e && (this.dx = e), null != t && (this.dy = t));
    };
    destroy = () => {
      (this.options.element.removeEventListener(
        "mousedown",
        this.handleMouseDown,
      ),
        this.options.element.removeEventListener(
          "touchstart",
          this.handleMouseDown,
        ),
        document.removeEventListener("mousemove", this.handleMouseMove),
        document.removeEventListener("touchmove", this.handleMouseMove),
        document.removeEventListener("mouseup", this.handleMouseUp),
        document.removeEventListener("touchend", this.handleMouseUp));
    };
  }
  class E {
    target;
    options;
    top;
    left;
    constructor(e, t) {
      ((this.target = e), (this.options = t), (this.top = 0), (this.left = 0));
    }
    handlePlacement = () => {
      const { element: e, placement: t, offset: s } = this.options,
        { offsetWidth: n, offsetHeight: i } = this.target,
        { top: o, left: r } = x(this.target),
        { offsetWidth: a, offsetHeight: l } = e;
      switch (t) {
        case "top-left":
          ((this.top = o - l - s), (this.left = r));
          break;
        case "top-center":
          ((this.top = o - l - s), (this.left = r + n / 2 - a / 2));
          break;
        case "top-right":
          ((this.top = o - l - s), (this.left = r + n - a));
          break;
        case "bottom-left":
          ((this.top = o + i + s), (this.left = r));
          break;
        case "bottom-center":
          ((this.top = o + i + s), (this.left = r + n / 2 - a / 2));
          break;
        case "bottom-right":
          ((this.top = o + i + s), (this.left = r + n - a));
          break;
        case "left-top":
          ((this.top = o), (this.left = r - a - s));
          break;
        case "left-center":
          ((this.top = o + i / 2 - l / 2), (this.left = r - a - s));
          break;
        case "left-bottom":
          ((this.top = o + i - l), (this.left = r - a - s));
          break;
        case "right-top":
          ((this.top = o), (this.left = r + n + s));
          break;
        case "right-center":
          ((this.top = o + i / 2 - l / 2), (this.left = r + n + s));
          break;
        case "right-bottom":
          ((this.top = o + i - l), (this.left = r + n + s));
      }
    };
    checkBoundary = () => {
      const { element: e } = this.options,
        { offsetWidth: t, offsetHeight: s } = e,
        { clientWidth: n, clientHeight: i } = document.documentElement;
      (this.top < window.scrollY
        ? (this.top = window.scrollY)
        : this.top + s > i + window.scrollY &&
          (this.top = i + window.scrollY - s),
        this.left < 0
          ? (this.left = window.scrollX)
          : this.left + t > n + window.scrollX &&
            (this.left = n + window.scrollX - t));
    };
    init = () => {
      const { element: e } = this.options,
        { width: t, height: s } = e.getBoundingClientRect();
      return (
        this.handlePlacement(),
        this.checkBoundary(),
        { top: this.top, left: this.left, width: t, height: s }
      );
    };
  }
  function S(e, { element: t, placement: s = "bottom-center", offset: n = 0 }) {
    return new E(e, { element: t, placement: s, offset: n }).init();
  }
  !(function () {
    let e = !1;
    (() => {
      if (!e) {
        e = !0;
        const t = "@xoLocalStorageCheck";
        try {
          return (
            window.localStorage.setItem(t, t),
            window.localStorage.removeItem(t),
            !0
          );
        } catch {
          return !1;
        }
      }
      return !0;
    })() && window.localStorage;
  })();
  class k extends HTMLElement {
    constructor() {
      super();
    }
    $attributeObserver$ = null;
    static defaultProps = {};
    static propTypes = {};
    static observedProps = [];
    props = {};
    state = {};
    _setProps = () => {
      const e = this.__proto__.constructor.propTypes,
        t = this.__proto__.constructor.defaultProps,
        s = g(this, { pick: Object.keys(e), types: e });
      this.props = { ...t, ...s };
    };
    setState(e) {
      const t = this.state;
      ("object" != typeof e || Array.isArray(e) || null === e
        ? "function" == typeof e && (this.state = { ...this.state, ...e(t) })
        : (this.state = { ...this.state, ...e }),
        this.stateUpdate(t));
    }
    setProps(e) {
      const t = this.props;
      ("object" != typeof e || Array.isArray(e) || null === e
        ? "function" == typeof e && (this.props = { ...this.props, ...e(t) })
        : (this.props = { ...this.props, ...e }),
        Object.entries(this.props).forEach(([e, t]) => {
          const s = e.includes("-") ? e : f.camelToKebab(e);
          "boolean" == typeof t
            ? n(this, s, t)
            : this.setAttribute(
                s,
                "string" == typeof t ? t : JSON.stringify(t),
              );
        }));
    }
    handlePropUpdate = () => {
      const e = this.__proto__.constructor.observedProps;
      e &&
        e.length &&
        ((this.$attributeObserver$ = new MutationObserver((t) => {
          t.forEach((t) => {
            const s = t.attributeName;
            if (s && "attributes" === t.type) {
              const n = f.kebabToCamel(s),
                i = t.oldValue,
                o = this.getAttribute(s);
              e.includes(n) &&
                i !== o &&
                (this._setProps(),
                this.propUpdate({ name: n, prevProp: i, nextProp: o }));
            }
          });
        })),
        this.$attributeObserver$.observe(this, {
          attributes: !0,
          attributeOldValue: !0,
          attributeFilter: e.map((e) => f.camelToKebab(e)),
        }));
    };
    connectedCallback() {
      (this._setProps(),
        this.setProps({}),
        this.mount(),
        this.handlePropUpdate());
    }
    disconnectedCallback() {
      (this.$attributeObserver$?.disconnect(), this.unmount());
    }
    emit(e, t) {
      const s = new CustomEvent(e, t);
      return (this.dispatchEvent(s), s);
    }
    stateUpdate(e) {}
    propUpdate({ name: e, prevProp: t, nextProp: s }) {}
    mount() {}
    unmount() {}
  }
  function A(e, t) {
    return (s) => {
      window.customElements.get(e) || window.customElements.define(e, s, t);
    };
  }
  (u(() => {
    const e = document.getElementById("popup-newsletter__modal"),
      t = e?.getAttribute("data-show"),
      s = localStorage.getItem("popup-newsletter-last-shown"),
      n =
        60 *
        parseInt(
          document.getElementById("popup-newsletter-data__cooldown")
            ?.textContent || "0",
          10,
        ) *
        1e3,
      i = window.location.pathname;
    e &&
      "hidden" != t &&
      ("all" === t ||
        ("home" === t && i.includes("pages/home")) ||
        "/" === i) &&
      (!s || Date.now() - parseInt(s, 10) >= n) &&
      (c(2e3).then(() => {
        xoModal.open("popup-newsletter");
      }),
      localStorage.setItem(
        "popup-newsletter-last-shown",
        Date.now().toString(),
      ));
  }),
    c(18e5).then(() => {
      xoModal.close("popup-newsletter");
    }),
    u(() => {
      const e = document.getElementById("popup-promotion__modal"),
        t = e?.getAttribute("data-show"),
        s = localStorage.getItem("popup-promotion-last-shown"),
        n =
          60 *
          parseInt(
            document.getElementById("popup-promotion-data__cooldown")
              ?.textContent || "0",
            10,
          ) *
          1e3,
        i = window.location.pathname;
      e &&
        "hidden" != t &&
        ("all" === t ||
          ("home" === t && i.includes("pages/home")) ||
          "/" === i) &&
        (!s || Date.now() - parseInt(s, 10) >= n) &&
        (c(2e3).then(() => {
          xoModal.open("popup-promotion");
        }),
        localStorage.setItem(
          "popup-promotion-last-shown",
          Date.now().toString(),
        ));
    }),
    c(18e5).then(() => {
      xoModal.close("popup-promotion");
    }));
  let C = class extends k {
    static propTypes = {
      xoCarouselBulletSelector: "string",
      xoDuration: "number",
    };
    static defaultProps = {
      xoCarouselBulletSelector: "xo-carousel-bullet",
      xoDuration: 100,
    };
    carouselEl = null;
    timeId = -1;
    prevPageIndex = -1;
    handleCarouselChange = (e) => {
      const { xoCarouselBulletSelector: t, xoDuration: s } = this.props,
        { activeIndex: n } = e.detail,
        { xoPerView: i, xoBreakpoints: r } = this.carouselEl.options,
        a = (function (e) {
          if (null == e) return;
          const t = o(e || {}),
            s = (function (e, t) {
              let s = {};
              for (let n = 0; n < e.length; n++) s = t(s, e[n], n);
              return s;
            })(t, (s, n, i) => {
              const o = parseInt(n.toString()) || 0,
                r = parseInt(t[i - 1]?.toString?.() || "0");
              return window.innerWidth > r && window.innerWidth <= o
                ? { ...s, ...e[n] }
                : s;
            });
          return o(s).length ? s : void 0;
        })(r),
        l = a?.perView ?? i,
        c = Math.ceil(n / l),
        u = Array.from(this.carouselEl.querySelectorAll(t)),
        h = u[c];
      if (null != h && this.prevPageIndex !== c)
        if (this.hasAttribute("xo-vertical")) {
          const e = u[this.prevPageIndex] ?? h,
            { top: t } = x(h),
            { top: n } = x(e),
            i = Math.abs(n - t) + e.offsetHeight,
            o = this.prevPageIndex < c;
          ((this.style.opacity = "1"),
            (this.style.width = `${h.offsetWidth}px`),
            window.clearTimeout(this.timeId),
            o
              ? ((this.style.top = `${e.offsetTop}px`),
                (this.style.height = `${i}px`),
                (this.timeId = window.setTimeout(() => {
                  ((this.style.top = `${h.offsetTop}px`),
                    (this.style.height = `${h.offsetHeight}px`));
                }, s)))
              : ((this.style.top = `${h.offsetTop}px`),
                (this.style.height = `${i}px`),
                (this.timeId = window.setTimeout(() => {
                  this.style.height = `${h.offsetHeight}px`;
                }, s))));
        } else {
          const e = u[this.prevPageIndex] ?? h,
            { left: t } = x(h),
            { left: n } = x(e),
            i = Math.abs(n - t) + e.offsetWidth,
            o = this.prevPageIndex < c;
          ((this.style.opacity = "1"),
            (this.style.height = `${h.offsetHeight}px`),
            window.clearTimeout(this.timeId),
            o
              ? ((this.style.left = `${e.offsetLeft}px`),
                (this.style.width = `${i}px`),
                (this.timeId = window.setTimeout(() => {
                  ((this.style.left = `${h.offsetLeft}px`),
                    (this.style.width = `${h.offsetWidth}px`));
                }, s)))
              : ((this.style.left = `${h.offsetLeft}px`),
                (this.style.width = `${i}px`),
                (this.timeId = window.setTimeout(() => {
                  this.style.width = `${h.offsetWidth}px`;
                }, s))));
        }
      this.prevPageIndex = c;
    };
    mount() {
      const { xoDuration: e } = this.props;
      ((this.carouselEl = this.closest("xo-carousel")),
        this.style.setProperty("--xo-duration", `${e}ms`),
        this.carouselEl &&
          this.carouselEl.addEventListener(
            "xo:carousel:change",
            this.handleCarouselChange,
          ));
    }
    unmount() {
      (window.clearTimeout(this.timeId),
        this.carouselEl?.removeEventListener(
          "xo:carousel:change",
          this.handleCarouselChange,
        ));
    }
  };
  C = (function (e, t, s, n) {
    var i,
      o = arguments.length,
      r =
        o < 3
          ? t
          : null === n
            ? (n = Object.getOwnPropertyDescriptor(t, s))
            : n;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate)
      r = Reflect.decorate(e, t, s, n);
    else
      for (var a = e.length - 1; a >= 0; a--)
        (i = e[a]) && (r = (o < 3 ? i(r) : o > 3 ? i(t, s, r) : i(t, s)) || r);
    return (o > 3 && r && Object.defineProperty(t, s, r), r);
  })([A("xo-carousel-pagination-bullet-active")], C);
  let L = class extends k {
    constructor() {
      (super(), this.updateCartUI());
    }
    updateCartUI() {
      const e = window.shopSettings,
        t = window.translations;
      fetch("/cart.js")
        .then((e) => e.json())
        .then((s) => {
          const n = s.total_price / 100,
            {
              freeShippingThreshold: i,
              currencyActive: o,
              currencyRate: r,
              showCurrencyCode: a,
            } = e;
          let { freeShippingNotice: l, freeShippingProgress: c } = t;
          const u = Math.round(i * r),
            h = Math.max(0, u - n);
          let d = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: o,
          }).format(h);
          (a && (d = `${d} ${o}`), (c = c.replace(/\{\{.*?\}\}/g, d)));
          const p = this.querySelector(".xo-cart-free-shipping__text"),
            m = this.querySelector(".xo-cart-free-shipping__progress");
          p &&
            m &&
            (n >= u
              ? ((p.innerHTML = l), m.classList.add("shakey"))
              : ((p.innerHTML = c), m.classList.remove("shakey")),
            m.style.setProperty(
              "--progress",
              `${Math.min(100, (n / u) * 100)}%`,
            ));
        })
        .catch((e) => console.error("Error fetching cart:", e));
    }
    mount() {
      this.updateCartUI();
      const e = window.fetch.bind(window);
      window.fetch = (...t) =>
        e(...t).then((e) => {
          const s =
            "string" == typeof t[0]
              ? t[0]
              : t[0] instanceof Request
                ? t[0].url
                : "";
          return (
            s &&
              (s.includes("/cart/add") || s.includes("/cart/change")) &&
              e.ok &&
              this.updateCartUI(),
            e
          );
        });
    }
    unmount() {}
    stateUpdate() {}
  };
  ((L = (function (e, t, s, n) {
    var i,
      o = arguments.length,
      r =
        o < 3
          ? t
          : null === n
            ? (n = Object.getOwnPropertyDescriptor(t, s))
            : n;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate)
      r = Reflect.decorate(e, t, s, n);
    else
      for (var a = e.length - 1; a >= 0; a--)
        (i = e[a]) && (r = (o < 3 ? i(r) : o > 3 ? i(t, s, r) : i(t, s)) || r);
    return (o > 3 && r && Object.defineProperty(t, s, r), r);
  })([A("xo-cart-free-shipping-custom")], L)),
    s(439));
  const I = "xo-currency-select";
  class T extends HTMLElement {
    inputEls = [];
    formEl = null;
    constructor() {
      (super(),
        (this.inputEls = Array.from(
          this.querySelectorAll(
            ".xo-currency-select__content .xo-currency-select__input",
          ),
        )),
        (this.formEl = this.querySelector(".xo-currency-select__form")));
    }
    handleChange = () => {
      this.formEl?.submit();
    };
    connectedCallback() {
      i(this.inputEls, (e) => {
        e.addEventListener("input", this.handleChange);
      });
    }
    disconnectedCallback() {
      i(this.inputEls, (e) => {
        e.removeEventListener("input", this.handleChange);
      });
    }
  }
  r({ [I]: T });
  const O = "xo-language-select";
  class P extends HTMLElement {
    inputEls = [];
    formEl = null;
    constructor() {
      (super(),
        (this.inputEls = Array.from(
          this.querySelectorAll(
            ".xo-language-select__content .xo-language-select__input",
          ),
        )),
        (this.formEl = this.querySelector(".xo-language-select__form")));
    }
    handleChange = () => {
      this.formEl?.submit();
    };
    connectedCallback() {
      i(this.inputEls, (e) => {
        e.addEventListener("input", this.handleChange);
      });
    }
    disconnectedCallback() {
      i(this.inputEls, (e) => {
        e.removeEventListener("input", this.handleChange);
      });
    }
  }
  function M() {
    const e = document.querySelector(".menu-hamburger-drawer-desktop--click"),
      t = Array.from(
        e?.querySelectorAll(".menu-hamburger-drawer-desktop__link") ?? [],
      );
    (i(t, (e) => {
      const s = e.parentElement;
      (s.querySelector(".menu-hamburger-drawer-desktop__sub-menu") ||
        s
          .querySelector(".menu-hamburger-drawer-desktop__mega-menu")
          ?.innerHTML.trim()) &&
        e.addEventListener("click", (s) => {
          s.preventDefault();
          const n = e.parentElement,
            o = n?.parentElement?.closest(
              ".menu-hamburger-drawer-desktop__item--click",
            );
          (i(t, (e) => {
            const t = e.parentElement;
            t?.classList.contains(
              "menu-hamburger-drawer-desktop__item--click",
            ) &&
              t !== n &&
              t?.classList.remove("menu-hamburger-drawer-desktop__item--open");
          }),
            n?.classList.contains(
              "menu-hamburger-drawer-desktop__item--click",
            ) &&
              n?.classList.toggle("menu-hamburger-drawer-desktop__item--open"),
            o?.classList.add("menu-hamburger-drawer-desktop__item--open"));
        });
    }),
      window.addEventListener("click", (s) => {
        e?.contains(s.target) ||
          i(t, (e) => {
            const t = e.parentElement;
            t?.classList.remove("menu-hamburger-drawer-desktop__item--open");
          });
      }));
  }
  function F() {
    const e = document.querySelector(".xo-menu-horizontal--click"),
      t = Array.from(e?.querySelectorAll(".xo-menu-horizontal__link") ?? []);
    (i(t, (e) => {
      const s = e.parentElement;
      (s.querySelector(".xo-menu-horizontal__sub-menu") ||
        s.querySelector(".xo-menu-horizontal__mega-menu")?.innerHTML.trim()) &&
        e.addEventListener("click", (s) => {
          s.preventDefault();
          const n = e.parentElement,
            o = n?.parentElement?.closest(".xo-menu-horizontal__item--click");
          (i(t, (e) => {
            const t = e.parentElement;
            t?.classList.contains("xo-menu-horizontal__item--click") &&
              t !== n &&
              t?.classList.remove("xo-menu-horizontal__item--open");
          }),
            n?.classList.contains("xo-menu-horizontal__item--click") &&
              n?.classList.toggle("xo-menu-horizontal__item--open"),
            o?.classList.add("xo-menu-horizontal__item--open"));
        });
    }),
      window.addEventListener("click", (s) => {
        e?.contains(s.target) ||
          i(t, (e) => {
            const t = e.parentElement;
            t?.classList.remove("xo-menu-horizontal__item--open");
          });
      }));
  }
  (r({ [O]: P }),
    M(),
    window.Shopify.designMode &&
      document.addEventListener("shopify:section:load", (e) => {
        e.target.querySelector(".menu-hamburger-drawer-desktop__list") && M();
      }),
    s(505),
    F(),
    window.Shopify.designMode &&
      document.addEventListener("shopify:section:load", (e) => {
        e.target.querySelector(".xo-menu-horizontal") && F();
      }));
  const R = document.querySelector(".xo-menu-scroll"),
    B = R?.querySelector(".xo-menu-scroll__list"),
    $ = Array.from(R?.querySelectorAll(".xo-menu-scroll__link") ?? []),
    D = R?.querySelector(".xo-menu-scroll__link--current");
  let q = !1,
    N = 0;
  if (B && D) {
    const { left: qe } = x(D),
      { left: Ne } = x(B);
    if (
      (B.scrollTo({ left: qe - Ne - (B.offsetWidth - D.offsetWidth) / 2 }), !b)
    ) {
      const Ue = new _({
        element: B,
        onStart: () => {
          ((q = !0), (N = B.scrollLeft));
        },
        onMove: ({ dx: e }) => {
          B.scrollTo({ left: N - e });
        },
        onEnd: () => {
          ((q = !1), Ue.setValue({ dx: 0 }));
        },
      });
      function He(e) {
        !q && e.preventDefault();
      }
      i($, (e) => {
        e.addEventListener("click", He);
      });
    }
  }
  function U() {
    var e = Error.call(this);
    return (
      (e.name = "Server error"),
      (e.message = "Something went wrong on the server"),
      (e.status = 500),
      e
    );
  }
  function H(e) {
    var t = Error.call(this);
    return (
      (t.name = "Not found"),
      (t.message = "Not found"),
      (t.status = e),
      t
    );
  }
  function V() {
    var e = Error.call(this);
    return (
      (e.name = "Server error"),
      (e.message = "Something went wrong on the server"),
      (e.status = 500),
      e
    );
  }
  function j(e) {
    var t = Error.call(this);
    return (
      (t.name = "Content-Type error"),
      (t.message = "Content-Type was not provided or is of wrong type"),
      (t.status = e),
      t
    );
  }
  function z(e) {
    var t = Error.call(this);
    return (
      (t.name = "JSON parse error"),
      (t.message = "JSON syntax error"),
      (t.status = e),
      t
    );
  }
  function Y(e, t, s, n) {
    var i = Error.call(this);
    return (
      (i.name = t),
      (i.message = s),
      (i.status = e),
      (i.retryAfter = n),
      i
    );
  }
  function K(e, t, s) {
    var n = Error.call(this);
    return ((n.name = t), (n.message = s), (n.status = e), n);
  }
  function W(e, t, s) {
    var n = Error.call(this);
    return ((n.name = t), (n.message = s), (n.status = e), n);
  }
  function X() {
    this.events = {};
  }
  function Q(e) {
    ((this.eventName = e), (this.callbacks = []));
  }
  function J(e) {
    ((this._store = {}),
      (this._keys = []),
      e && e.bucketSize
        ? (this.bucketSize = e.bucketSize)
        : (this.bucketSize = 20));
  }
  function G(e, t) {
    var s = "";
    return (
      (t = t || null),
      Object.keys(e).forEach(function (n) {
        var i = n + "=";
        switch (
          (t && (i = t + "[" + n + "]"),
          (function (e) {
            return Object.prototype.toString.call(e).slice(8, -1).toLowerCase();
          })(e[n]))
        ) {
          case "object":
            s += G(e[n], t ? i : n);
            break;
          case "array":
            s += i + "=" + e[n].join(",") + "&";
            break;
          default:
            (t && (i += "="), (s += i + encodeURIComponent(e[n]) + "&"));
        }
      }),
      s
    );
  }
  ((X.prototype.on = function (e, t) {
    var s = this.events[e];
    (s || ((s = new Q(e)), (this.events[e] = s)), s.registerCallback(t));
  }),
    (X.prototype.off = function (e, t) {
      var s = this.events[e];
      s &&
        s.callbacks.indexOf(t) > -1 &&
        (s.unregisterCallback(t),
        0 === s.callbacks.length && delete this.events[e]);
    }),
    (X.prototype.dispatch = function (e, t) {
      var s = this.events[e];
      s && s.fire(t);
    }),
    (Q.prototype.registerCallback = function (e) {
      this.callbacks.push(e);
    }),
    (Q.prototype.unregisterCallback = function (e) {
      var t = this.callbacks.indexOf(e);
      t > -1 && this.callbacks.splice(t, 1);
    }),
    (Q.prototype.fire = function (e) {
      this.callbacks.slice(0).forEach(function (t) {
        t(e);
      });
    }),
    (J.prototype.set = function (e, t) {
      if (this.count() >= this.bucketSize) {
        var s = this._keys.splice(0, 1);
        this.delete(s);
      }
      return (this._keys.push(e), (this._store[e] = t), this._store);
    }),
    (J.prototype.get = function (e) {
      return this._store[e];
    }),
    (J.prototype.has = function (e) {
      return Boolean(this._store[e]);
    }),
    (J.prototype.count = function () {
      return Object.keys(this._store).length;
    }),
    (J.prototype.delete = function (e) {
      var t = Boolean(this._store[e]);
      return (delete this._store[e], t && !this._store[e]);
    }));
  var Z,
    ee,
    te =
      ((Z = function (e, t, s, n, i) {
        var o = new XMLHttpRequest(),
          r = e + "/suggest.json";
        ((o.onreadystatechange = function () {
          if (o.readyState !== XMLHttpRequest.DONE);
          else {
            var e = o.getResponseHeader("Content-Type");
            if (o.status >= 500) return void i(new V());
            if (404 === o.status) return void i(new H(o.status));
            if (
              "string" != typeof e ||
              null === e.toLowerCase().match("application/json")
            )
              return void i(new j(o.status));
            if (417 === o.status) {
              try {
                var t = JSON.parse(o.responseText);
                i(new K(o.status, t.message, t.description));
              } catch (e) {
                i(new z(o.status));
              }
              return;
            }
            if (422 === o.status) {
              try {
                var r = JSON.parse(o.responseText);
                i(new W(o.status, r.message, r.description));
              } catch (e) {
                i(new z(o.status));
              }
              return;
            }
            if (429 === o.status) {
              try {
                var a = JSON.parse(o.responseText);
                i(
                  new Y(
                    o.status,
                    a.message,
                    a.description,
                    o.getResponseHeader("Retry-After"),
                  ),
                );
              } catch (e) {
                i(new z(o.status));
              }
              return;
            }
            if (200 === o.status) {
              try {
                var l = JSON.parse(o.responseText);
                ((l.query = s), n(l));
              } catch (e) {
                i(new z(o.status));
              }
              return;
            }
            try {
              var c = JSON.parse(o.responseText);
              i(new U(o.status, c.message, c.description));
            } catch (e) {
              i(new z(o.status));
            }
          }
        }),
          o.open("get", r + "?q=" + encodeURIComponent(s) + "&" + t),
          o.setRequestHeader("Content-Type", "application/json"),
          o.send());
      }),
      (ee = null),
      function () {
        var e = this,
          t = arguments;
        (clearTimeout(ee),
          (ee = setTimeout(function () {
            ((ee = null), Z.apply(e, t));
          }, 10)));
      });
  function se(e) {
    if (!e) throw new TypeError("No config object was specified");
    var t = e;
    ((this._retryAfter = null),
      (this._currentQuery = null),
      (this.dispatcher = new X()),
      (this.cache = new J({ bucketSize: 40 })),
      (this.searchPath = t.search_path || "/search"),
      t.search_path && delete t.search_path,
      (this.configParams = G(t)));
  }
  function ne(e) {
    return "string" != typeof e
      ? null
      : e.trim().replace(" ", "-").toLowerCase();
  }
  ((se.SEARCH_PATH = "/search"),
    (se.TYPES = {
      PRODUCT: "product",
      PAGE: "page",
      ARTICLE: "article",
      COLLECTION: "collection",
    }),
    (se.FIELDS = {
      AUTHOR: "author",
      BODY: "body",
      PRODUCT_TYPE: "product_type",
      TAG: "tag",
      TITLE: "title",
      VARIANTS_BARCODE: "variants.barcode",
      VARIANTS_SKU: "variants.sku",
      VARIANTS_TITLE: "variants.title",
      VENDOR: "vendor",
    }),
    (se.UNAVAILABLE_PRODUCTS = { SHOW: "show", HIDE: "hide", LAST: "last" }),
    (se.prototype.query = function (e) {
      try {
        !(function (e) {
          var t;
          if (null == e)
            throw (
              ((t = new TypeError("'query' is missing")).type = "argument"),
              t
            );
          if ("string" != typeof e)
            throw (
              ((t = new TypeError("'query' is not a string")).type =
                "argument"),
              t
            );
        })(e);
      } catch (e) {
        return void this.dispatcher.dispatch("error", e);
      }
      if ("" === e) return this;
      this._currentQuery = ne(e);
      var t = this.cache.get(this._currentQuery);
      return t
        ? (this.dispatcher.dispatch("success", t), this)
        : (te(
            this.searchPath,
            this.configParams,
            e,
            function (e) {
              (this.cache.set(ne(e.query), e),
                ne(e.query) === this._currentQuery &&
                  ((this._retryAfter = null),
                  this.dispatcher.dispatch("success", e)));
            }.bind(this),
            function (e) {
              (e.retryAfter && (this._retryAfter = e.retryAfter),
                this.dispatcher.dispatch("error", e));
            }.bind(this),
          ),
          this);
    }),
    (se.prototype.on = function (e, t) {
      return (this.dispatcher.on(e, t), this);
    }),
    (se.prototype.off = function (e, t) {
      return (this.dispatcher.off(e, t), this);
    }));
  var ie = {
    search_path: se.SEARCH_PATH,
    resources: {
      type: [se.TYPES.PRODUCT],
      options: {
        unavailable_products: se.UNAVAILABLE_PRODUCTS.LAST,
        fields: [
          se.FIELDS.TITLE,
          se.FIELDS.VENDOR,
          se.FIELDS.PRODUCT_TYPE,
          se.FIELDS.VARIANTS_TITLE,
        ],
      },
    },
  };
  function oe(e) {
    if (
      !(
        e &&
        e.selectors &&
        e.selectors.input &&
        ae(e.selectors.input) &&
        e.selectors.result &&
        ae(e.selectors.result) &&
        e.resultTemplateFct &&
        ce(e.resultTemplateFct) &&
        e.numberOfResultsTemplateFct &&
        ce(e.numberOfResultsTemplateFct) &&
        e.loadingResultsMessageTemplateFct &&
        ce(e.loadingResultsMessageTemplateFct)
      )
    ) {
      var t = new TypeError("PredictiveSearchComponent config is not valid");
      throw ((t.type = "argument"), t);
    }
    var s, n, i;
    ((this.nodes =
      ((s = e.selectors),
      {
        input: document.querySelector(s.input),
        reset: document.querySelector(s.reset),
        result: document.querySelector(s.result),
      })),
      (i = this.nodes) && i.input && i.result && "INPUT" === i.input.tagName
        ? ((this._searchKeyword = ""),
          (this.resultTemplateFct = e.resultTemplateFct),
          (this.numberOfResultsTemplateFct = e.numberOfResultsTemplateFct),
          (this.loadingResultsMessageTemplateFct =
            e.loadingResultsMessageTemplateFct),
          (this.numberOfResults = e.numberOfResults || 4),
          (this.classes = {
            visibleVariant: e.visibleVariant
              ? e.visibleVariant
              : "predictive-search-wrapper--visible",
            itemSelected: e.itemSelectedClass
              ? e.itemSelectedClass
              : "predictive-search-item--selected",
            clearButtonVisible: e.clearButtonVisibleClass
              ? e.clearButtonVisibleClass
              : "predictive-search__clear-button--visible",
          }),
          (this.selectors = {
            searchResult: e.searchResult
              ? e.searchResult
              : "[data-search-result]",
          }),
          (this.callbacks = (function (e) {
            return {
              onBodyMousedown: e.onBodyMousedown,
              onBeforeOpen: e.onBeforeOpen,
              onOpen: e.onOpen,
              onBeforeClose: e.onBeforeClose,
              onClose: e.onClose,
              onInputFocus: e.onInputFocus,
              onInputKeyup: e.onInputKeyup,
              onInputBlur: e.onInputBlur,
              onInputReset: e.onInputReset,
              onBeforeDestroy: e.onBeforeDestroy,
              onDestroy: e.onDestroy,
            };
          })(e)),
          (n = this.nodes.input).setAttribute("autocorrect", "off"),
          n.setAttribute("autocomplete", "off"),
          n.setAttribute("autocapitalize", "off"),
          n.setAttribute("spellcheck", "false"),
          this._addInputEventListeners(),
          this._addBodyEventListener(),
          this._addAccessibilityAnnouncer(),
          this._toggleClearButtonVisibility(),
          (this.predictiveSearch = new se(
            e.PredictiveSearchAPIConfig ? e.PredictiveSearchAPIConfig : ie,
          )),
          this.predictiveSearch.on(
            "success",
            this._handlePredictiveSearchSuccess.bind(this),
          ),
          this.predictiveSearch.on(
            "error",
            this._handlePredictiveSearchError.bind(this),
          ))
        : console.warn("Could not find valid nodes"));
  }
  function re(e) {
    return Object.prototype.toString.call(e);
  }
  function ae(e) {
    return "[object String]" === re(e);
  }
  function le(e) {
    return "[object Boolean]" === re(e);
  }
  function ce(e) {
    return "[object Function]" === re(e);
  }
  function ue() {
    const e = document.querySelector(".xo-predictive-search"),
      t = e?.dataset.locales;
    if (!t) throw new Error("Missing data-locales attribute");
    return v(t);
  }
  function he({ url: e, title: t }) {
    return `\n    <a href="${e}" data-search-result class='xo-predictive-search__item'>\n      <span>${t}</span>\n    </a>\n  `;
  }
  function de({ url: e, title: t }) {
    return `\n    <a href="${e}" data-search-result class='xo-predictive-search__item'>\n      <span>${t}</span>\n    </a>\n  `;
  }
  function pe({ url: e, image: t, title: s, vendor: n, price: i }) {
    let truncatedTitle = s.length > 42 ? s.slice(0, 42) + '…' : s;
    let o, r, a;
    return (
      (o = show_currency_code ? "inline-block" : "none"),
      (r = show_vendor ? "block" : "none"),
      (a = show_price ? "flex" : "none"),
      `\n    <a href="${e}" data-search-result class='xo-predictive-search__item'>\n      <img src="${t}" alt="${s}" class=''/>\n      <div>\n        <div class='xo-predictive-search__product-title'>${truncatedTitle}</div>\n        <div class='xo-predictive-search__product-vendor' style='display:${r}'>${n}</div>\n        <div class='xo-predictive-search__product-price' style='display:${a}'><span>${currency_symbol}${i}</span><span style='display: ${o}'>${currency_code}</span></div>\n      </div>\n    </a>\n  `
    );
  }
  function me({ url: e, image: t, title: s }) {
    return `\n    <a href="${e}" data-search-result class='xo-predictive-search__item'>\n      <img src="${t}" alt="${s}" class='xo-predictive-search__item-image'/>\n      <span class='xo-predictive-search__article-title'>${s}</span>\n    </a>\n  `;
  }
  ((oe.prototype.isResultVisible = !1),
    (oe.prototype.results = {}),
    (oe.prototype._latencyTimer = null),
    (oe.prototype._resultNodeClicked = !1),
    (oe.prototype._addInputEventListeners = function () {
      var e = this.nodes.input,
        t = this.nodes.reset;
      e &&
        ((this._handleInputFocus = this._handleInputFocus.bind(this)),
        (this._handleInputBlur = this._handleInputBlur.bind(this)),
        (this._handleInputKeyup = this._handleInputKeyup.bind(this)),
        (this._handleInputKeydown = this._handleInputKeydown.bind(this)),
        e.addEventListener("focus", this._handleInputFocus),
        e.addEventListener("blur", this._handleInputBlur),
        e.addEventListener("keyup", this._handleInputKeyup),
        e.addEventListener("keydown", this._handleInputKeydown),
        t &&
          ((this._handleInputReset = this._handleInputReset.bind(this)),
          t.addEventListener("click", this._handleInputReset)));
    }),
    (oe.prototype._removeInputEventListeners = function () {
      var e = this.nodes.input;
      (e.removeEventListener("focus", this._handleInputFocus),
        e.removeEventListener("blur", this._handleInputBlur),
        e.removeEventListener("keyup", this._handleInputKeyup),
        e.removeEventListener("keydown", this._handleInputKeydown));
    }),
    (oe.prototype._addBodyEventListener = function () {
      ((this._handleBodyMousedown = this._handleBodyMousedown.bind(this)),
        document
          .querySelector("body")
          .addEventListener("mousedown", this._handleBodyMousedown));
    }),
    (oe.prototype._removeBodyEventListener = function () {
      document
        .querySelector("body")
        .removeEventListener("mousedown", this._handleBodyMousedown);
    }),
    (oe.prototype._removeClearButtonEventListener = function () {
      var e = this.nodes.reset;
      e && e.removeEventListener("click", this._handleInputReset);
    }),
    (oe.prototype._handleBodyMousedown = function (e) {
      if (this.isResultVisible && null !== this.nodes)
        if (
          e.target.isEqualNode(this.nodes.input) ||
          this.nodes.input.contains(e.target) ||
          e.target.isEqualNode(this.nodes.result) ||
          this.nodes.result.contains(e.target)
        )
          this._resultNodeClicked = !0;
        else if (ce(this.callbacks.onBodyMousedown)) {
          var t = this.callbacks.onBodyMousedown(this.nodes);
          le(t) && t && this.close();
        } else this.close();
    }),
    (oe.prototype._handleInputFocus = function (e) {
      if (ce(this.callbacks.onInputFocus)) {
        var t = this.callbacks.onInputFocus(this.nodes);
        if (le(t) && !t) return !1;
      }
      return (e.target.value.length > 0 && this._search(), !0);
    }),
    (oe.prototype._handleInputBlur = function () {
      return (
        setTimeout(
          function () {
            if (ce(this.callbacks.onInputBlur)) {
              var e = this.callbacks.onInputBlur(this.nodes);
              if (le(e) && !e) return !1;
            }
            return (
              !document.activeElement.isEqualNode(this.nodes.reset) &&
              (this._resultNodeClicked
                ? ((this._resultNodeClicked = !1), !1)
                : void this.close())
            );
          }.bind(this),
        ),
        !0
      );
    }),
    (oe.prototype._addAccessibilityAnnouncer = function () {
      ((this._accessibilityAnnouncerDiv = window.document.createElement("div")),
        this._accessibilityAnnouncerDiv.setAttribute(
          "style",
          "position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;",
        ),
        this._accessibilityAnnouncerDiv.setAttribute(
          "data-search-announcer",
          "",
        ),
        this._accessibilityAnnouncerDiv.setAttribute("aria-live", "polite"),
        this._accessibilityAnnouncerDiv.setAttribute("aria-atomic", "true"),
        this.nodes.result.parentElement.appendChild(
          this._accessibilityAnnouncerDiv,
        ));
    }),
    (oe.prototype._removeAccessibilityAnnouncer = function () {
      this.nodes.result.parentElement.removeChild(
        this._accessibilityAnnouncerDiv,
      );
    }),
    (oe.prototype._updateAccessibilityAttributesAfterSelectingElement =
      function (e, t) {
        (this.nodes.input.setAttribute("aria-activedescendant", t.id),
          e && e.removeAttribute("aria-selected"),
          t.setAttribute("aria-selected", !0));
      }),
    (oe.prototype._clearAriaActiveDescendant = function () {
      this.nodes.input.setAttribute("aria-activedescendant", "");
    }),
    (oe.prototype._announceNumberOfResultsFound = function (e) {
      var t = this._accessibilityAnnouncerDiv.innerHTML,
        s = this.numberOfResultsTemplateFct(e);
      (t === s && (s += "&nbsp;"),
        (this._accessibilityAnnouncerDiv.innerHTML = s));
    }),
    (oe.prototype._announceLoadingState = function () {
      this._accessibilityAnnouncerDiv.innerHTML =
        this.loadingResultsMessageTemplateFct();
    }),
    (oe.prototype._handleInputKeyup = function (e) {
      if (ce(this.callbacks.onInputKeyup)) {
        var t = this.callbacks.onInputKeyup(this.nodes);
        if (le(t) && !t) return !1;
      }
      if (
        (this._toggleClearButtonVisibility(),
        this.isResultVisible && null !== this.nodes)
      ) {
        if (38 === e.keyCode) return (this._navigateOption(e, "UP"), !0);
        if (40 === e.keyCode) return (this._navigateOption(e, "DOWN"), !0);
        if (13 === e.keyCode) return (this._selectOption(), !0);
        27 === e.keyCode && this.close();
      }
      return (
        e.target.value.length <= 0
          ? (this.close(), this._setKeyword(""))
          : e.target.value.length > 0 && this._search(),
        !0
      );
    }),
    (oe.prototype._handleInputKeydown = function (e) {
      (13 === e.keyCode &&
        null != this._getSelectedOption() &&
        e.preventDefault(),
        (38 !== e.keyCode && 40 !== e.keyCode) || e.preventDefault());
    }),
    (oe.prototype._handleInputReset = function (e) {
      if ((e.preventDefault(), ce(this.callbacks.onInputReset))) {
        var t = this.callbacks.onInputReset(this.nodes);
        if (le(t) && !t) return !1;
      }
      return (
        (this.nodes.input.value = ""),
        this.nodes.input.focus(),
        this._toggleClearButtonVisibility(),
        this.close(),
        !0
      );
    }),
    (oe.prototype._navigateOption = function (e, t) {
      var s = this._getSelectedOption();
      if (s)
        if ("DOWN" === t) {
          var n = s.nextElementSibling;
          n &&
            (s.classList.remove(this.classes.itemSelected),
            n.classList.add(this.classes.itemSelected),
            this._updateAccessibilityAttributesAfterSelectingElement(s, n));
        } else {
          var i = s.previousElementSibling;
          i &&
            (s.classList.remove(this.classes.itemSelected),
            i.classList.add(this.classes.itemSelected),
            this._updateAccessibilityAttributesAfterSelectingElement(s, i));
        }
      else {
        var o = this.nodes.result.querySelector(this.selectors.searchResult);
        (o.classList.add(this.classes.itemSelected),
          this._updateAccessibilityAttributesAfterSelectingElement(null, o));
      }
    }),
    (oe.prototype._getSelectedOption = function () {
      return this.nodes.result.querySelector("." + this.classes.itemSelected);
    }),
    (oe.prototype._selectOption = function () {
      var e = this._getSelectedOption();
      e && e.querySelector("a, button").click();
    }),
    (oe.prototype._search = function () {
      var e = this.nodes.input.value;
      this._searchKeyword !== e &&
        (clearTimeout(this._latencyTimer),
        (this._latencyTimer = setTimeout(
          function () {
            ((this.results.isLoading = !0),
              this._announceLoadingState(),
              this.nodes.result.classList.add(this.classes.visibleVariant),
              (this.nodes.result.innerHTML = this.resultTemplateFct(
                this.results,
              )));
          }.bind(this),
          500,
        )),
        this.predictiveSearch.query(e),
        this._setKeyword(e));
    }),
    (oe.prototype._handlePredictiveSearchSuccess = function (e) {
      (clearTimeout(this._latencyTimer),
        (this.results = e.resources.results),
        (this.results.isLoading = !1),
        (this.results.products = this.results.products.slice(
          0,
          this.numberOfResults,
        )),
        (this.results.canLoadMore =
          this.numberOfResults <= this.results.products.length),
        (this.results.searchQuery = this.nodes.input.value),
        this.results.products.length > 0 || this.results.searchQuery
          ? ((this.nodes.result.innerHTML = this.resultTemplateFct(
              this.results,
            )),
            this._announceNumberOfResultsFound(this.results),
            this.open())
          : ((this.nodes.result.innerHTML = ""), this._closeOnNoResults()));
    }),
    (oe.prototype._handlePredictiveSearchError = function () {
      (clearTimeout(this._latencyTimer),
        (this.nodes.result.innerHTML = ""),
        this._closeOnNoResults());
    }),
    (oe.prototype._closeOnNoResults = function () {
      (this.nodes &&
        this.nodes.result.classList.remove(this.classes.visibleVariant),
        (this.isResultVisible = !1));
    }),
    (oe.prototype._setKeyword = function (e) {
      this._searchKeyword = e;
    }),
    (oe.prototype._toggleClearButtonVisibility = function () {
      this.nodes.reset &&
        (this.nodes.input.value.length > 0
          ? this.nodes.reset.classList.add(this.classes.clearButtonVisible)
          : this.nodes.reset.classList.remove(this.classes.clearButtonVisible));
    }),
    (oe.prototype.open = function () {
      if (!this.isResultVisible) {
        if (ce(this.callbacks.onBeforeOpen)) {
          var e = this.callbacks.onBeforeOpen(this.nodes);
          if (le(e) && !e) return !1;
        }
        return (
          this.nodes.result.classList.add(this.classes.visibleVariant),
          this.nodes.input.setAttribute("aria-expanded", !0),
          (this.isResultVisible = !0),
          (ce(this.callbacks.onOpen) && this.callbacks.onOpen(this.nodes)) || !0
        );
      }
    }),
    (oe.prototype.close = function () {
      if (!this.isResultVisible) return !0;
      if (ce(this.callbacks.onBeforeClose)) {
        var e = this.callbacks.onBeforeClose(this.nodes);
        if (le(e) && !e) return !1;
      }
      return (
        this.nodes &&
          this.nodes.result.classList.remove(this.classes.visibleVariant),
        this.nodes.input.setAttribute("aria-expanded", !1),
        this._clearAriaActiveDescendant(),
        this._setKeyword(""),
        ce(this.callbacks.onClose) && this.callbacks.onClose(this.nodes),
        (this.isResultVisible = !1),
        (this.results = {}),
        !0
      );
    }),
    (oe.prototype.destroy = function () {
      if ((this.close(), ce(this.callbacks.onBeforeDestroy))) {
        var e = this.callbacks.onBeforeDestroy(this.nodes);
        if (le(e) && !e) return !1;
      }
      var t;
      return (
        this.nodes.result.classList.remove(this.classes.visibleVariant),
        (t = this.nodes.input).removeAttribute("autocorrect", "off"),
        t.removeAttribute("autocomplete", "off"),
        t.removeAttribute("autocapitalize", "off"),
        t.removeAttribute("spellcheck", "false"),
        this._removeInputEventListeners(),
        this._removeBodyEventListener(),
        this._removeAccessibilityAnnouncer(),
        this._removeClearButtonEventListener(),
        ce(this.callbacks.onDestroy) && this.callbacks.onDestroy(this.nodes),
        !0
      );
    }),
    (oe.prototype.clearAndClose = function () {
      ((this.nodes.input.value = ""), this.close());
    }));
  const fe = new oe({
    selectors: {
      input: '[data-predictive-search-input="header"]',
      reset: '[data-predictive-search-reset="header"]',
      result: '[data-predictive-search-result="header"]',
    },
    PredictiveSearchAPIConfig: {
      search_path: "/search",
      resources: {
        type: ["product", "article", "page", "collection"],
        options: {
          unavailable_products: "last",
          fields: ["title", "vendor", "product_type", "variants.title"],
        },
      },
    },
    resultTemplateFct: function (e) {
      return e?.products.length > 0 ||
        e?.articles.length > 0 ||
        e?.pages.length > 0 ||
        e?.collections.length > 0
        ? `\n    <div class="xo-predictive-search__inner">\n      <xo-container>\n        <xo-grid>\n          ${(function (
            e,
          ) {
            return e?.collections.length > 0 || e?.pages.length > 0
              ? `\n    <div style="${(function (e) {
                  return e?.products.length > 0 || e?.articles.length > 0
                    ? "--xs: 12; --sm: 4; --md: 4"
                    : "--xs: 12; --sm: 6; --md: 12";
                })(e)}">\n      ${(function (e) {
                  return e?.collections.length > 0
                    ? `\n    <h3>${ue().collections}</h3>\n    <div class='xo-predictive-search__item-list xo-predictive-search__item-list--article'>\n      ${e.collections.map(de).join("")}\n    </div>\n  `
                    : "";
                })(e)}\n      ${(function (e) {
                  return e?.pages.length > 0
                    ? `\n    <h3>${ue().pages}</h3>\n    <div class='xo-predictive-search__item-list'>\n      ${e.pages.map(he).join("")}\n    </div>\n  `
                    : "";
                })(e)}\n    </div>\n  `
              : "";
          })(e)}\n          ${(function (e) {
            return e?.products.length > 0
              ? `\n    <div style="${(function (e) {
                  return e?.pages.length > 0 || e?.collections.length > 0
                    ? e?.articles.length > 0
                      ? "--xs: 12; --sm: 4; --md: 4"
                      : "--xs: 12; --sm: 8; --md: 8"
                    : "--xs: 12; --sm: 6; --md: 12";
                })(
                  e,
                )}">\n      <h3>${ue().products}</h3>\n      <xo-grid style='--col-width: 15rem' class='xo-predictive-search__item-list'>\n        ${e.products.map(pe).join("")}\n      </xo-grid>\n    </div>\n  `
              : "";
          })(e)}\n          ${(function (e) {
            return e?.articles.length > 0
              ? `\n    <div style="${(function (e) {
                  return e?.pages.length > 0 || e?.collections.length > 0
                    ? e?.products.length > 0
                      ? "--xs: 12; --sm: 4; --md: 4"
                      : "--xs: 12; --sm: 8; --md: 8"
                    : "--xs: 12; --sm: 6; --md: 12";
                })(
                  e,
                )}">\n    <h3>${ue().articles}</h3>\n      <xo-grid style='--col-width: 15rem' class='xo-predictive-search__item-list'>\n        ${e.articles.map(me).join("")}\n      </xo-grid>\n    </div>\n  `
              : "";
          })(e)}\n        </xo-grid>\n      </xo-container>\n    </div>\n  `
        : "";
    },
    numberOfResultsTemplateFct: (e) =>
      1 === e.products.length
        ? "one result found"
        : "[results_count] results found".replace(
            "[results_count]",
            `${e.products.length}`,
          ),
    loadingResultsMessageTemplateFct: () => "loading",
    onInputFocus: (e) => {
      e.input.value && fe.open();
    },
    onInputKeyup: () => !0,
    onInputBlur: () => !1,
  });
  s(975);
  const ve = "xo-copy";
  class ye extends HTMLElement {
    static defaultOptions = { xoUrl: "" };
    get options() {
      const e = g(this, { pick: ["xoUrl"], types: { xoUrl: "string" } });
      return { ...ye.defaultOptions, ...e };
    }
    handleClick = async () => {
      try {
        const { options: e } = this,
          { xoUrl: t } = e;
        (await navigator.clipboard.writeText(t),
          xoToast({ name: "share-copy" }));
      } catch (e) {
        console.error(e);
      }
    };
    connectedCallback() {
      this.addEventListener("click", this.handleClick);
    }
    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
    }
  }
  r({ [ve]: ye });
  const ge = "xo-address-form",
    be = "edit-address-";
  class we extends HTMLElement {
    unsubscribe = () => {};
    addressId = "";
    selectCountryEl = null;
    connectedCallback() {
      this.unsubscribe = xoStore.subscribe("xo-modal", ({ data: e }) => {
        const t = w(e).find((e) => e.isOpen);
        t &&
          t.isOpen &&
          (t.options.xoName?.includes(be)
            ? ((this.addressId = t.options.xoName.replace(be, "")),
              this.bindCountry())
            : "create-address" === t.options.xoName &&
              ((this.addressId = "new"), this.bindCountry()));
      });
    }
    bindCountry = () => {
      this.selectCountryEl = document.querySelector(
        `select[name="address[country]"][data-country-id="${this.addressId}"]`,
      );
      const e = this.selectCountryEl?.getAttribute("data-default"),
        t = this.selectCountryEl?.querySelector(`option[value="${e}"]`);
      if (t) {
        t.setAttribute("selected", "selected");
        const e = this.getProvinces(t);
        this.renderProvinces(e);
      }
      const s = document.querySelector(
          `select[name="address[province]"][data-province-id="${this.addressId}"]`,
        ),
        n = s?.getAttribute("data-default"),
        i = s?.querySelector(`option[value="${n}"]`);
      (i && i.setAttribute("selected", "selected"),
        this.selectCountryEl?.addEventListener(
          "change",
          this.handleCountryChange,
        ));
    };
    getProvinces = (e) => v(e.getAttribute("data-provinces") ?? "[]");
    handleCountryChange = (e) => {
      const t = e.target,
        s = t.querySelector(`option[value="${t.value}"]`);
      if (s) {
        const e = this.getProvinces(s);
        this.renderProvinces(e);
      }
    };
    renderProvinces = (e) => {
      const t = document.querySelector(
        `select[name="address[province]"][data-province-id="${this.addressId}"]`,
      );
      if (t) {
        t.innerHTML = e
          .map(([e, t]) => `<option value="${e}">${t}</option>`)
          .join("");
        const s = t.closest(".js-address-province"),
          n = e.length > 0;
        s && (n ? s.classList.remove("hide") : s.classList.add("hide"));
      }
    };
    disconnectedCallback() {
      (this.unsubscribe(),
        this.selectCountryEl?.removeEventListener(
          "change",
          this.handleCountryChange,
        ));
    }
  }
  (r({ [ge]: we }), s(208));
  const xe = window.Shopify;
  class _e {
    productInfoEl;
    productDataEl;
    productData;
    CAROUSEL_NAME =
      window.innerWidth > 767
        ? "product-information-desktop"
        : "product-information-mobile";
    variantSelected = {};
    cartFormUnsubscribe = () => {};
    constructor(e) {
      ((this.productInfoEl = document.querySelector(e)),
        (this.productDataEl = this.productInfoEl?.querySelector(
          "xo-product-data script",
        )),
        (this.productData = v(this.productDataEl?.textContent ?? "")));
    }
    getMediaId() {
      const e = Object.values(this.variantSelected || {});
      let t = this.productData.variants.find(
        (t) => JSON.stringify(t.options.sort()) === JSON.stringify(e.sort()),
      )?.featured_media?.id;
      return (
        t ||
          (t = this.productData.variants.find((e) => e.featured_media)
            ?.featured_media?.id),
        t
      );
    }
    handleCarousel(e) {
      const t = Array.from(
          this.productInfoEl?.querySelectorAll(
            `xo-carousel[xo-name*="${this.CAROUSEL_NAME}"] xo-carousel-slide[data-media-id]:not([xo-cloned])`,
          ) ?? [],
        ),
        s = t.findIndex(
          (t) => t.getAttribute("data-media-id") === e?.toString(),
        ),
        n = t?.[0]?.closest(`xo-carousel[xo-name*="${this.CAROUSEL_NAME}"]`),
        i = n?.getAttribute("xo-name");
      i && xoCarousel.goTo(i, s);
    }
    handleScrollTo(e) {
      const t = this.productInfoEl?.querySelector(
        `xo-animate[data-media-id="${e}"]`,
      );
      if (t) {
        const { top: e } = x(t);
        window.scrollTo({ top: e, behavior: "smooth" });
      }
    }
    init() {
      this.cartFormUnsubscribe = cartFormSubscribe(() => {
        const e = this.productInfoEl?.getAttribute("xo-section-id"),
          t = this.productInfoEl?.getAttribute("xo-product-id"),
          s = `${e}/${t}`,
          n = getCartFormState()?.[s];
        if (n) {
          const e = n.variantSelected;
          if (JSON.stringify(e) !== JSON.stringify(this.variantSelected)) {
            this.variantSelected = e;
            const t = this.getMediaId();
            (this.handleCarousel(t), this.handleScrollTo(t));
          }
        }
      });
    }
    unsubscribe = () => {
      this.cartFormUnsubscribe();
    };
  }
  class Ee extends HTMLElement {
    modelViewerUI;
    constructor() {
      super();
      const e = this.querySelector(".xb-product-model__poster");
      e && e.addEventListener("click", this.loadContent.bind(this));
    }
    loadContent() {
      if (!this.getAttribute("loaded")) {
        const e = document.createElement("div"),
          t = this.querySelector("template");
        if (t) {
          const s = t.content.firstElementChild;
          s && e.appendChild(s.cloneNode(!0));
        }
        this.setAttribute("loaded", "true");
        const s = e.querySelector("model-viewer");
        s && this.appendChild(s).focus();
      }
      xe.loadFeatures([
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }
    setupModelViewerUI(e) {
      e ||
        (this.modelViewerUI = new xe.ModelViewerUI(
          this.querySelector("model-viewer"),
        ));
    }
  }
  window.customElements.define("xo-product-model", Ee);
  class Se {
    TERMS_NAME = "@term";
    inputPolicyEls = document.querySelectorAll(
      ".xo-field-checkbox__input[name='agree_policy'][type='checkbox']",
    );
    constructor() {
      this.init();
    }
    setTerms = (e) => {
      localStorage.setItem(this.TERMS_NAME, e ? "true" : "false");
    };
    getTerms = () => {
      const e = localStorage.getItem(this.TERMS_NAME);
      return null != e && "true" === e;
    };
    handleChange = (e) => {
      const t = e.target;
      (this.setTerms(t.checked), this.termsBinding());
    };
    termsBinding = () => {
      const e = document.querySelectorAll(".terms-binding"),
        t = this.getTerms();
      e.forEach((e) => {
        t
          ? e.classList.remove("disabled-button")
          : e.classList.add("disabled-button");
      });
    };
    setDefaultChecked = (e) => {
      e.checked = this.getTerms();
    };
    init() {
      this.inputPolicyEls.length > 0 &&
        (this.inputPolicyEls.forEach((e) => {
          (e.addEventListener("input", this.handleChange),
            this.setDefaultChecked(e));
        }),
        this.termsBinding());
    }
  }
  const ke = new _e("xo-product[xo-product-information]");
  (ke.init(), new Se());
  const Ae = document.querySelector('xo-modal[xo-name="quick-view"]');
  Ae &&
    new MutationObserver(() => {
      const e = new _e(
        "xo-product-quick-view xo-product[xo-product-information]",
      );
      var t, s;
      ((s = "xo-active"),
        "false" !== (t = Ae).getAttribute(s) && t.hasAttribute(s)
          ? (e.init(), ke.unsubscribe(), new Se())
          : (ke.init(), e.unsubscribe()));
    }).observe(Ae, { attributes: !0, attributeFilter: ["xo-active"] });
  const Ce = "xo-list",
    Le = "xo-list-trigger",
    Ie = "xo-list-portal",
    Te = "xo-list-item",
    Oe = {
      none: window.xoAnimate.none,
      zoom: window.xoAnimate.zoom(!0),
      fade: window.xoAnimate.move(),
      "fade-up": window.xoAnimate.move({ dy: 50 }),
      "fade-down": window.xoAnimate.move({ dy: -50 }),
      "fade-left": window.xoAnimate.move({ dx: 50 }),
      "fade-right": window.xoAnimate.move({ dx: -50 }),
    };
  function Pe(e, t) {
    window.xoStore.set("xo-list", (s) => {
      const n = s?.data || {},
        i = n?.[e] || {};
      return {
        ...s,
        data: { ...n, [e]: { ...i, isOpen: null == t ? !i.isOpen : t } },
        listNameTrigger: e,
      };
    });
  }
  function Me() {
    return window.xoStore.get("xo-list");
  }
  function Fe(e, t) {
    return window.xoStore.subscribe("xo-list", e, t);
  }
  class Re extends HTMLElement {
    unsubscribe = () => {};
    animated = (function () {
      const e = new l();
      let t = -1,
        s = -1,
        n = -1,
        i = 0,
        o = -1,
        r = -1;
      function a({
        to: t,
        from: s,
        duration: n = 1e3,
        friction: a = 1,
        reverseEasing: l = !1,
        easing: c,
        onStart: u,
        onUpdate: h,
        onEnd: d,
      }) {
        let p = null;
        return (
          (i = s),
          u?.(i),
          e.emit("start", i),
          cancelAnimationFrame(r),
          (r = requestAnimationFrame(function o(u) {
            p || (p = u);
            const d = u - p,
              m = Math.min(d / n, 1);
            ((i = s + (t - s) * m * a),
              "function" == typeof c &&
                (i = l ? s + (t - s) * (1 - c(1 - m)) : s + (t - s) * c(m)),
              e.emit("update", i),
              h?.(i),
              m < 1 && (r = requestAnimationFrame(o)));
          })),
          (o = window.setTimeout(() => {
            (cancelAnimationFrame(r),
              clearTimeout(o),
              (i = t),
              h?.(i),
              d?.(i),
              e.emit("update", i),
              e.emit("end", i));
          }, n)),
          () => {
            (clearTimeout(o), cancelAnimationFrame(r));
          }
        );
      }
      return (
        (a.onStart = (s) => ((t = e.on("start", s)), () => e.off(t))),
        (a.onUpdate = (t) => ((s = e.on("update", t)), () => e.off(s))),
        (a.onEnd = (t) => ((n = e.on("end", t)), () => e.off(n))),
        (a.off = () => {
          (e.off(t),
            e.off(s),
            e.off(n),
            cancelAnimationFrame(r),
            clearTimeout(o));
        }),
        (a.getValue = () => i),
        a
      );
    })();
    prevIsOpen = !1;
    name = "";
    info = [];
    buttonEl = null;
    options = null;
    connectedCallback() {
      (window.addEventListener("resize", this.handler),
        window.addEventListener("scroll", this.handler),
        this.addEventListener("click", this.handleForTabsComponent),
        (this.unsubscribe = Fe(this.listener)));
    }
    disconnectedCallback() {
      (this.unsubscribe(),
        this.animated.off(),
        window.removeEventListener("resize", this.handler),
        window.removeEventListener("scroll", this.handler),
        this.removeEventListener("click", this.handleForTabsComponent));
    }
    handleForTabsComponent = (e) => {
      if (e.target instanceof HTMLElement) {
        const i = Me(),
          o =
            "xo-tabs-trigger" === e.target.tagName.toLowerCase()
              ? e.target
              : e.target.closest("xo-tabs-trigger"),
          r = o?.closest?.(Te),
          a = Array.from(document.querySelectorAll(Ce)).find(
            (e) => e.name === i.listNameTrigger,
          );
        if ((o && r && (o.widthFromList = r.offsetWidth), r && a)) {
          const e = a.querySelectorAll(Te),
            o = e[e.length - 1],
            l = this.info.findIndex((e) => e.element === o),
            c = this.info.findIndex((e) => e.element === r);
          null != c &&
            null != l &&
            ((t = i.listNameTrigger),
            (s = c),
            (n = l),
            window.xoStore.set("xo-list", (e) => {
              const i = e?.data || {},
                o = i?.[t] || {};
              return {
                ...e,
                data: {
                  ...i,
                  [t]: {
                    ...o,
                    idxs: d(o?.idxs || [], (e) => (e === s ? n : e)),
                  },
                },
              };
            })("xo-list/replaceLastId"));
        }
      }
      var t, s, n;
    };
    handler = () => {
      if (!this.options) return;
      const { xoPortalPlacement: e, xoPortalOffset: t } = this.options;
      if (this.buttonEl) {
        const s = S(this.buttonEl, { placement: e, offset: t, element: this });
        ((this.style.top = s.top - window.scrollY + "px"),
          (this.style.left = `${s.left}px`));
      }
    };
    handleOpen = () => {
      if (!this.options) return;
      const {
        xoPortalAnimate: e,
        xoPortalEasing: t,
        xoPortalDuration: s,
        xoPortalPlacement: n,
        xoPortalOffset: i,
        xoPortalClass: o,
      } = this.options;
      if (this.buttonEl) {
        o && this.classList.add(o);
        const r = S(this.buttonEl, { placement: n, offset: i, element: this });
        ((this.style.top = r.top - window.scrollY + "px"),
          (this.style.left = `${r.left}px`),
          this.animated({
            from: 0,
            to: 1,
            duration: s,
            onUpdate: (s) => {
              Oe[e] && Oe[e](this, { isOpen: !0, easing: h[t], value: s });
            },
          }));
      }
    };
    handleClose = () => {
      if (!this.options) return;
      const {
        xoPortalAnimate: e,
        xoPortalEasing: t,
        xoPortalDuration: s,
      } = this.options;
      this.animated({
        from: 1,
        to: 0,
        duration: s,
        onUpdate: (s) => {
          Oe[e] && Oe[e](this, { isOpen: !1, easing: h[t], value: s });
        },
      });
    };
    listener = (e) => {
      const { name: t, info: s } = this;
      if (e?.data?.[t]) {
        const o = Array.from(document.querySelectorAll(Ce)).find(
            (t) => t.name === e.listNameTrigger,
          ),
          r = o?.querySelectorAll?.(Te),
          { idxs: a = [], isOpen: l } = e.data[t];
        (i(s, ({ element: e, parentElement: t }, s) => {
          a.includes(s)
            ? this.appendChild(e)
            : r && t.insertBefore(e, t.children[r.length - 1]);
        }),
          this.prevIsOpen !== !!l &&
            (l
              ? (this.handleOpen(), n(this, "xo-active", !0))
              : (this.handleClose(), n(this, "xo-active", !1)),
            (this.prevIsOpen = !!l)));
      }
    };
  }
  class Be extends HTMLElement {
    unsubscribe = () => {};
    name = "";
    portalEl = null;
    _options;
    static defaultOptions = {
      xoPortalAnimate: "fade-up",
      xoPortalDuration: 300,
      xoPortalEasing: "decay",
      xoPortalPlacement: "bottom-right",
      xoPortalOffset: 10,
      xoPortalClass: "",
      xoPortalClickHide: !0,
    };
    get options() {
      return { ...Be.defaultOptions, ...this._options };
    }
    set options(e) {
      this._options = e;
    }
    static get observedAttributes() {
      return ["xo-observed"];
    }
    setOptions = () => {
      this.options = g(this, {
        pick: [
          "xoPortalAnimate",
          "xoPortalDuration",
          "xoPortalEasing",
          "xoPortalPlacement",
          "xoPortalOffset",
          "xoPortalClass",
          "xoPortalClickHide",
        ],
        types: {
          xoPortalAnimate: "string",
          xoPortalDuration: "number",
          xoPortalEasing: "string",
          xoPortalPlacement: "string",
          xoPortalOffset: "number",
          xoPortalClass: "string",
          xoPortalClickHide: "boolean",
        },
      });
    };
    handleOutsideClick = (e) => {
      const { xoPortalClickHide: t } = this.options,
        { name: s } = this,
        n = Me(),
        i = window.xoStore.get("xo-popover"),
        o = !!w(i.data).find((e) => e.isOpen)?.isOpen;
      if (n?.data?.[s] && !o) {
        const { isOpen: i } = n.data[s],
          o = e.target;
        t
          ? i && !this.contains(o) && Pe(this.name)
          : !i ||
            this.contains(o) ||
            this.portalEl?.contains(o) ||
            Pe(this.name);
      }
    };
    listener = (e) => {
      const { name: t } = this;
      if (e?.data?.[t]) {
        const { idxs: s = [], isOpen: i } = e.data[t];
        (n(this, "xo-visible", !!s.length), n(this, "xo-active", i));
      }
    };
    handleClick = () => {
      (this.portalEl &&
        ((this.portalEl.buttonEl = this),
        (this.portalEl.options = this.options)),
        Pe(this.name));
    };
    connectedCallback() {
      (this.setOptions(),
        this.addEventListener("click", this.handleClick),
        window.addEventListener("click", this.handleOutsideClick),
        (this.unsubscribe = Fe(this.listener)));
    }
    attributeChangedCallback(e, t, s) {
      "xo-observed" === e && t !== s && this.setOptions();
    }
    disconnectedCallback() {
      (this.removeEventListener("click", this.handleClick),
        window.removeEventListener("click", this.handleOutsideClick),
        this.unsubscribe());
    }
  }
  let $e = 0;
  class De extends HTMLElement {
    name = "";
    info = [];
    portalEl = null;
    buttonElement = null;
    resizeObserver = null;
    idleId = -1;
    constructor() {
      (super(), $e++, (this.name = `horizontal-list-${$e}`));
    }
    get childElements() {
      return Array.from(this.querySelectorAll(Te));
    }
    hasButton(e) {
      return !!e && e.tagName.toLowerCase() === Le;
    }
    handler = () => {
      const e = this.buttonElement?.scrollWidth || 0,
        t = this.offsetWidth - e,
        s = [];
      var n, o;
      (this.portalEl &&
        ((this.portalEl.name = this.name), (this.portalEl.info = this.info)),
        i(
          this.info,
          (
            { element: e, parentElement: n, position: i, width: o, left: r },
            l,
          ) => {
            e !== this.buttonElement &&
              (r + o >= t
                ? s.push(l)
                : ((function (e, t) {
                    window.xoStore.set("xo-list", (s) => {
                      const n = s?.data || {},
                        i = n?.[e] || {},
                        o = a(i?.idxs || [], (e) => e !== t);
                      return { ...s, data: { ...n, [e]: { ...i, idxs: o } } };
                    });
                  })(this.name, l),
                  n.insertBefore(e, n.children[i])));
          },
        ),
        (n = this.name),
        (o = s),
        window.xoStore.set("xo-list", (e) => {
          const t = e?.data || {},
            s = t?.[n] || {};
          return { ...e, data: { ...t, [n]: { ...s, idxs: o } } };
        }),
        s.length || Pe(this.name, !1));
    };
    setInfo = () => {
      const { left: e } = x(this);
      this.info = d(this.childElements, (t) => {
        const { left: s } = x(t),
          n = t.parentElement;
        return {
          element: t,
          position: Array.from(n.children).indexOf(t),
          parentElement: n,
          left: s - e,
          width: t.offsetWidth,
        };
      });
    };
    renderPortal = () => {
      this.portalEl &&
        ((this.portalEl.name = this.name),
        (this.portalEl.info = this.info),
        Array.from(document.body.children).includes(this.portalEl) ||
          document.body.appendChild(this.portalEl));
    };
    handleButton = () => {
      this.hasButton(this.buttonElement) &&
        ((this.buttonElement.name = this.name),
        (this.buttonElement.portalEl = this.portalEl));
    };
    connectedCallback() {
      ((this.portalEl = document.createElement(Ie)),
        (this.buttonElement = this.querySelector(Le)),
        this.setInfo(),
        this.renderPortal(),
        this.handleButton(),
        this.handler(),
        (this.resizeObserver = new ResizeObserver(() => {
          this.idleId = requestIdleCallback(this.handler);
        })),
        this.resizeObserver.observe(this));
    }
    disconnectedCallback() {
      (this.resizeObserver?.disconnect(),
        this.portalEl?.remove?.(),
        cancelIdleCallback(this.idleId));
    }
  }
  (window.xoStore.create("xo-list", {
    initialState: { data: {}, listNameTrigger: "" },
  }),
    r({ [Ie]: Re, [Le]: Be, [Ce]: De }));
})();